import React from "react";
import {
  UniversalLoginProvider,
  isUniversalLoginConfigured,
} from "@bto/shared";
import {
  AUTH_CALLBACK_URL,
  UNIVERSAL_LOGIN_PAGE_URL,
} from "../utils/urlConstants";

const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";
const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "";

let providerUniversalLogoutInProgress = false;

interface ProviderUniversalLogoutOptions {
  logoutParams: {
    returnTo: string;
  };
}

type ProviderUniversalLogoutHandler = (
  options: ProviderUniversalLogoutOptions,
) => void;

export const isProviderUniversalLoginConfigured = (): boolean =>
  isUniversalLoginConfigured({
    clientId: AUTH0_CLIENT_ID,
    domain: AUTH0_DOMAIN,
  });

export const isProviderUniversalLogoutInProgress = (): boolean =>
  providerUniversalLogoutInProgress;

export const startProviderUniversalLogout = (
  logout: ProviderUniversalLogoutHandler,
): void => {
  providerUniversalLogoutInProgress = true;
  logout({
    logoutParams: {
      returnTo: `${window.location.origin}${UNIVERSAL_LOGIN_PAGE_URL}`,
    },
  });
};

export const ProviderUniversalLoginProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  if (!isProviderUniversalLoginConfigured()) {
    return <>{children}</>;
  }

  return (
    <UniversalLoginProvider
      audience={AUTH0_AUDIENCE}
      callbackPath={AUTH_CALLBACK_URL}
      clientId={AUTH0_CLIENT_ID}
      domain={AUTH0_DOMAIN}
    >
      {children}
    </UniversalLoginProvider>
  );
};
